import React, { useEffect, useState } from 'react';

import { Loading } from '../components/loading/Loading';
import { useQueryPartnerConfig } from '../queries/config/hooks/useQueryPartnerConfig';

export const PartnerConfigProvider: React.FC = ({ children }) => {
  const [isLoading, setIsLoading] = useState(true);
  const { data } = useQueryPartnerConfig({ variables: { domain: window.runtime_env?.REACT_APP_PARTNER_DOMAIN || process.env.REACT_APP_PARTNER_DOMAIN || window.location.hostname } });

  useEffect(() => {
    if (data?.partnerConfig?.styling) {
      const customPrefixUrl = data?.partnerConfig?.applicationSettings?.results?.find((item: { code: string, value: string }) => item.code === 'whitelabel.custom_base_path')?.value;
      const faqIsDisabled = data?.partnerConfig?.applicationSettings?.results?.find((item: { code: string, value: string }) => item.code === 'travellerapp.faq.disabled')?.value.toLowerCase() === 'true';
      // @ts-ignore
      window.tz_globalConfigs = {
        ...window.tz_globalConfigs,
        helpdeskUrl: data?.partnerConfig?.helpdeskUrl || undefined,
        helpdeskUrlHide: data?.partnerConfig?.applicationSettings?.results?.find?.((item: {code: string, value: boolean}) => item.code === 'travellerapp.helpdeskUrl.disabled')?.value === 'true',
        transferTimelineEnabled: data?.partnerConfig?.applicationSettings?.results?.find?.((item: {code: string, value: boolean}) => item.code === 'common.transfertimeline.enabled')?.value === 'true',
        styling: {
          ...data.partnerConfig.styling,
        },
        customUrlPrefix: customPrefixUrl,
        faqIsDisabled,
      };

      if (customPrefixUrl && window.location.pathname.indexOf(customPrefixUrl) === -1) {
        const newUrl = new URL(window.location.href);
        newUrl.pathname = `${customPrefixUrl}${newUrl.pathname}`;
        window.location.href = newUrl.toString();
      }
      setIsLoading(false);
    }
  }, [data]);

  if (isLoading) {
    return <Loading />;
  }

  return (
    <>
      {children}
    </>
  );
};
